import { render, staticRenderFns } from "./previewTempate.vue?vue&type=template&id=27fe5916&scoped=true&"
import script from "./previewTempate.vue?vue&type=script&lang=js&"
export * from "./previewTempate.vue?vue&type=script&lang=js&"
import style0 from "./previewTempate.vue?vue&type=style&index=0&id=27fe5916&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fe5916",
  null
  
)

export default component.exports